import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';


export type FinanceMonthPeriod = {
  id: string;
  date: string;
  payout: number;
  cashpayItemsCount: number;
  insuranceItemsCount: number;
  submittedItemsCount: number;
  lateFeeSessionsCount: number;
  hasCalculationsWarning: boolean;
};


export const getFinanceMonths = async (providerId: string, params: {
  rangeFrom: string;
  rangeTo: string;
  cursor?: string;
  limit?: number | null;
}) =>
  restClient.request<{
    cursor: string;
    data: FinanceMonthPeriod[];
  }>(`/api/v1/provider/${providerId}/finances/months`, {
    method: 'POST',
    data: snakecaseKeys(params),
  });
